import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from '../../../utilities/TableUtil';
import { normalColumn, dateColumn, actionEditColumn } from '../../../components/DataTable/DataTable.js';
import * as bodyStyle from '../../../components/DataTable/ConsBodyStyle.js';


export default function P402List2({ dataTable, setDialog, action, setAction, data, submitForm }) {

    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyEdit = (rowData) => setDialog({ dialog: true, action: 'แก้ไข', data: rowData })

    const headerLabel = <span className="hidden-responsive">เพิ่มเจ้าหน้าที่บริษัทคู่สัญญา</span>;
    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive"
                label={headerLabel}
                icon="pi pi-plus"
                disabled={(action && action.action === 'บันทึก') ? true : false}
                onClick={() => setDialog({ dialog: true, action: 'บันทึก' })}
                autoFocus
            />
            {/* <span className="p-input-icon-left span-responsive" >
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น"
                className="btn-responsive"
                onInput={(e) => setGlobalFilter(e.target.value)}
                />
            </span> */}
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            {/* <div className="card"> */}
            <DataTable
                // ref={(el) => dt = el}
                value={dataTable}
                dataKey="id"
                paginator
                first={pageConf.first}
                rows={pageConf.rows}
                onPage={(e) => onPageChange(e, setPageConf)}
                rowsPerPageOptions={rowsPerPageOptions()}
                paginatorTemplate={paginatorTemplate()}
                currentPageReportTemplate={currentPageReportTemplate()}
                header={header}
                // globalFilter={globalFilter}
                emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                selectionMode="single"
            >

                <Column field="seqPk" header="ลำดับที่" body={(e) => normalColumn(e, 'seqPk', 'ลำดับ')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column sortable field="staffName" header="ชื่อ-นามสกุล" body={(e) => normalColumn(e, 'staffName', 'ชื่อ-นามสกุล')} headerStyle={{ textAlign: 'center', width: '20%' }} bodyStyle={{ overflowWrap: 'anywhere' }} />
                <Column sortable field="staffPosition" header="ตำแหน่ง" body={(e) => normalColumn(e, 'staffPosition', 'ตำแหน่ง')} style={{ textAlign: 'center', width: '20%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="staffTelephone" header="เบอร์ติอต่อ" body={(e) => normalColumn(e, 'staffTelephone', 'เบอร์ติอต่อ')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="statusDesc" header="สถานะ" body={(e) => normalColumn(e, 'statusDesc', 'สถานะ')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column sortable field="updateUserName" header="ผู้บันทึกแก้ไข" body={(e) => normalColumn(e, 'updateUserName', 'ผู้บันทึกแก้ไข')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column sortable field="updateDt" header="วันที่-เวลาที่แก้ไข" body={(e) => dateColumn(e, true, 'updateDt', 'วันที่-เวลาที่แก้ไข')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column header="แก้ไข" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: 'center', width: '6%' }} bodyStyle={bodyStyle.TXT_CENTER} ></Column>

            </DataTable>

            <div className="p-col-12 p-md-12">
                <div className="p-grid" style={{ textAlign: "center", marginTop: 10 }}>
                    <div className="p-col-12">
                        <Button
                            className="p-button p-button-success btn-srh-responsive"
                            icon="pi pi-save"
                            // label={action.action}
                            label={"บันทึก"}
                            style={{ width: 130 }}
                            onClick={() => submitForm(data)}
                        />

                        <Button
                            className="p-button-secondary p-button btn-srh-responsive"
                            icon="pi pi-arrow-left"
                            label="กลับหน้าจอหลัก"
                            style={{ width: 130, marginLeft: '5px' }}
                            onClick={() => { setAction({ tab: 1 }) }}
                        />
                        {/* {
                                action && action.action === 'แก้ไข' ?(
                                <Button
                                    className="p-button-danger p-button btn-srh-responsive"
                                    icon="pi pi-trash"
                                    label="ลบรายการ"
                                    style={{ width: 130, marginLeft: '5px' }}
                                    onClick={() => submitForm(data,'ลบรายการ')}
                                />

                                ):('')
                            } */}
                    </div>
                </div>
            </div>
            {/* </div> */}
        </div>
    )
}
